import React, { useRef } from 'react';
import Tracking from './tracking';
import {
    Ad,
    AdImage,
    AdImageFrame,
    AdContent,
    AdContentTitle,
    AdLink,
    AdBadge,
} from '@finn-no/troika-react-ads';
import { ImageFormat } from '@finn-no/troika-react-auto-image-format';
import { useTrackInscreen } from './hooks';

type CmsArticleProps = {
    ad: import('./types').Recommendation;
    trackAdClick: (adId: string, trackingUrlClick: string[]) => void;
    tracking: Tracking;
    position: string;
};

const CmsArticle: React.FC<CmsArticleProps> = (props) => {
    const { ad, trackAdClick, tracking } = props;
    const trackingUrlClick = Tracking.getClickUrl(ad);
    const inscreenTrackingUrls = Tracking.getInscreenUrl(ad);

    const domRef = useRef<HTMLDivElement>(null);

    useTrackInscreen({
        adId: ad.itemId,
        tracking,
        ref: domRef,
        inscreenTrackingUrls,
        pulseContext: ad?.tracking?.pulse,
    });

    return (
        <Ad
            key={ad.itemId}
            ref={domRef}
            onClick={() => {
                trackAdClick(ad.itemId, trackingUrlClick);
                tracking.trackClickWithPulse(ad?.tracking?.pulse);
            }}
            data-finn-rendertype="cms"
        >
            <AdImage>
                <AdImageFrame>
                    <ImageFormat
                        alt=""
                        src={ad.image?.url}
                        ratio="1by1"
                        className="u-bg-milk data-podlet-server-nyttiginformasjon"
                        type={ad.image?.isAbsolute ? undefined : 'logo'}
                        centered
                    />
                </AdImageFrame>
            </AdImage>
            <AdContent>
                <AdContentTitle>
                    <AdLink href={ad.url} title={ad.heading}>
                        {ad.heading}
                    </AdLink>
                </AdContentTitle>
                {ad.overlay?.cms?.label && (
                    <AdBadge>{ad.overlay?.cms?.label}</AdBadge>
                )}
            </AdContent>
        </Ad>
    );
};
export default CmsArticle;
